<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        edit-mode
        @backBtnClicked="redirectToOverview"
    >
        <kgr-dog-member-relations-data-provider
            v-slot="relationsScope"
            :dog-id="dogId"
            :callback="onRelationsLoaded"
        >
            <div class="animated fadeIn">
                <h1 class="kgr-headline kgr-headline--h2 kgr-headline--text kgr-headline--firstInText">
                    {{ $t('Verknüpfte Mitglieder') }}
                </h1>
                <kgr-dog-member-relations-form
                    :club-id="clubId"
                    :relations="relationsScope.data"
                    :error="error"
                    :pending-create="pendingRelationCreate"
                    @addRelation="onAdd($event, relationsScope.reload)"
                />
                <kgr-dog-member-relation-list
                    :relations="ownerRelations"
                    :pending-remove="pendingRelationRemove"
                    :is-deletable="true"
                    :headline="$t('club.dog.memberRelation.association.owner')"
                    @remove="onRemove($event, relationsScope.reload)"
                />
                <kgr-dog-member-relation-list
                    :relations="handlerRelations"
                    :pending-remove="pendingRelationRemove"
                    :is-deletable="true"
                    :headline="$t('club.dog.memberRelation.association.handler')"
                    @remove="onRemove($event, relationsScope.reload)"
                />
            </div>
        </kgr-dog-member-relations-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import DogMemberRelationList from '../../components/dog/DogMemberRelationList.vue';
import DogMemberRelationsDataProvider from '../../components/data-provider/DogMemberRelationsDataProvider.vue';
import DogMemberRelationsForm from '../../components/dog/DogMemberRelationsForm.vue';
import DogRepository from '../../js/repository/DogRepository.js';
import Error from '../../js/model/Error.js';
import FormScaffold from '../../components/common/form/FormScaffold.vue';

export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-dog-member-relations-data-provider': DogMemberRelationsDataProvider,
        'kgr-dog-member-relations-form': DogMemberRelationsForm,
        'kgr-dog-member-relation-list': DogMemberRelationList,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        dogId: {
            type: String,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pendingRelationCreate: false,
            pendingRelationRemove: false,
            error: new Error(),
            relations: [],
        };
    },
    computed: {
        ownerRelations() {
            return this.relations.filter((r) => r.association === 'owner');
        },
        handlerRelations() {
            return this.relations.filter((r) => r.association === 'handler');
        },
    },
    watch: {
    },
    created() {
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onRelationsLoaded(relations) {
            this.relations = relations;
        },
        onAdd(relation, reload) {
            this.error = new Error();
            this.pendingRelationCreate = true;
            DogRepository.addMemberRelation(this.clubId, this.dogId, relation)
                .then(() => {
                    this.$notify.success('Der Hund wurde erfolgreich hinzugefügt');
                    reload();
                })
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                })
                .finally(() => this.pendingRelationCreate = false);
        },
        onRemove(relation, reload) {
            this.pendingRelationRemove = true;

            DogRepository.removeMemberRelation(this.dogId, relation.id)
                .then(() => {
                    this.pendingRelationRemove = false;
                    this.$notify.success('Hund erfoglreich entfernt');
                    reload();
                })
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                    this.pendingRelationRemove = false;
                });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
